import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { formatDistance } from 'date-fns';

@Pipe({ name: 'timeUntilNow' })
@Injectable({
  providedIn: 'root',
})
export class TimeUntilNowPipe implements PipeTransform {
  transform(
    date: string,
    options?: {
      includeSeconds?: boolean;
      addSuffix?: boolean;
      locale?: Locale;
    },
  ): string {
    return formatDistance(new Date(date), new Date(), options);
  }
}
